import type { Board } from "./board";
import { XY } from "./xy";

function getDiagonalDistance(p1: XY, p2: XY): number {
	const deltaX = p1.x - p2.x;
	const deltaY = p1.y - p2.y;
	return Math.max(Math.abs(deltaX), Math.abs(deltaY));
}

function lerp(start: number, end: number, t: number): number {
	return start + t * (end - start);
}

export function getLine(origin: XY, destination: XY): XY[] {
	const points: XY[] = [];
	const diagonalDistance = getDiagonalDistance(origin, destination);

	for (let step = 0; step <= diagonalDistance; step++) {
		const t = diagonalDistance === 0 ? 0 : step / diagonalDistance;
		const lerpX = lerp(origin.x, destination.x, t);
		const lerpY = lerp(origin.y, destination.y, t);
		const xy = new XY(Math.round(lerpX), Math.round(lerpY));

		// Avoid duplicates (the Java version uses a Set)
		if (points.length === 0 || !points[points.length - 1].equals(xy)) {
			points.push(xy);
		}
	}

	return points;
}

export function isInLineOfSight(board: Board, origin: XY, target: XY): boolean {
	const line = getLine(origin, target);
	return line.filter((xy) => !xy.equals(origin) && !xy.equals(target)).every((xy) => board.isPassable(xy));
}
